import { RequestError } from '../errors/request.error';
import type { UsersCurrentData } from '../hooks/users/use-users-current';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const isNonBlankString = (value: unknown): boolean => typeof value === 'string' && value.trim().length > 0;

const isCurrentUserData = (value: unknown): value is UsersCurrentData => {
  if (!isRecord(value) || !isNonBlankString(value.id) || !isNonBlankString(value.name)) {
    return false;
  }

  return (
    Array.isArray(value.effectivePermissions) && value.effectivePermissions.every((permission: unknown) =>
      isRecord(permission) && typeof permission.name === 'string' && Array.isArray(permission.scopes)
      && permission.scopes.every((scope: unknown) => typeof scope === 'string'),
    )
  );
};

export const parseCurrentUserResponse = (value: unknown): UsersCurrentData => {
  // A proxy can briefly serve the SPA document with HTTP 200 during backend replacement.
  // Reject it before query success can establish an authenticated user or reach permission guards.
  if (!isCurrentUserData(value)) {
    throw new RequestError({
      status: 502,
      error: 'server',
      code: 'INVALID_CURRENT_USER_RESPONSE',
      message: 'Je gebruikersgegevens konden niet worden geladen. Probeer opnieuw.',
    });
  }

  return value;
};
